import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule, ServicePathProviderService } from '@blk/cwp-ng-framework';
import { ApiModule, BASE_PATH } from '@blk/wealth-web-endpoint';

import { WealthWebApiService } from './services';

export function getBasePath(servicePathProvider: ServicePathProviderService): string {
	return `${servicePathProvider.getServicePath('api-gateway')}/wealth-web`;
	// For localhost
	// return '//localhost:8080';
}

@NgModule({
	imports: [
		CommonModule,
		ApiModule,
		CwpNgFrameworkModule
	],
	providers: [
		{
			provide: BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getBasePath
		},
		WealthWebApiService
	]
})
export class WealthWebModule { }
